module.exports = __webpack_public_path__ + "media/images/fonts/Feather-75fae9bd7f31d99f5b5195f530a4056f7bafa56675aa22f140f735b619ad965f.svg";